$(document).ready(function () {
  /* VIDEO MODAL START */
  // Getting all the info about the hidden modal
  var myModal = $('#myModal')
  var siteBaseHolder = $(myModal).find('.base-site-store')[0]
  var siteBaseUrl = siteBaseHolder && $(siteBaseHolder).val()

  var myModalContent
  var modalVideo
  var modalExternalVideo
  var modalExternalVideoMobile
  var modalVideoContent
  var modalH2
  var modalDate
  var modalDescription
  var modalFacebook
  var modalTwitter
  var modalLinkedin
  var iframes

  // Video modal styles
  var externalStyles
  var externalMobileStyles
  var internalStyles
  var internalMobileStyles

  // If not in the frontpage we need to get every field from the hidden modal to feed it
  if (!siteBaseUrl) {
    var myModalContent = $(myModal).find('.modal-body__content')[0]
    var modalVideo = $(myModal).find('.modal-body__image')[0].children[0].children[0]
    var modalExternalVideo = $(myModal).find('.modal-external-video')[0]
    var modalExternalVideoMobile = $(myModal).find('.modal-external-video-mobile')[0]
    var modalVideoContent = $(myModalContent).children('video')[0].children[0]
    var modalH2 = $(myModalContent).children('h2')[0]
    var modalDate = $(myModalContent).children('.date')[0]
    var modalDescription = $(myModalContent).children('p')[0]
    var modalFacebook = $(myModal).find('a.open-facebook')
    var modalTwitter = $(myModal).find('a.open-twitter')
    var modalLinkedin = $(myModal).find('a.open-linkedin')
    iframes = document.getElementsByClassName('iframe-select')

    // Storing modal styles
    externalStyles = $(modalExternalVideo).parent()[0].style
    externalMobileStyles = $(modalExternalVideoMobile).parent()[0].style
    internalStyles = $(modalVideo).parent()[0].style
    internalMobileStyles = $(modalVideoContent).parent()[0].style
  }

  // Getting the items storing info to be display
  $('.video-modal-selector').each(function () {
    var typeHolder = $(this).children('.item-type-store')[0]
    var type = typeHolder && $(typeHolder).val()

    // Only videos open modals
    if (type == 'video') {
      // Storing every info about the specific video clicked
      var imageItem = $(this).children('.imageItem') && $(this).children('.imageItem')[0]
      var infoItem = $(this).children('.infoItem') && $(this).children('.infoItem')[0]
      var dateItem = $(infoItem).children('.dateItem') && $(infoItem).children('.dateItem')[0]
      var titleItem = $(infoItem).children('.titleItem') && $(infoItem).children('.titleItem')[0]
      var ingressItem = $(infoItem).children('.ingressItem') && $(infoItem).children('.ingressItem')[0]

      var imgs = $(imageItem).find('div.img') && $(imageItem).find('div.img')[0] && $(imageItem).find('div.img')[0].children
      var imgUrl = ''
      var videoUrl = ''

      for (const img of imgs) {
        if (img.className == 'video-item-image') {
          imgUrl = img.src
        } else if (img.className == 'video-item-play') {
          var videoHolder = $(this).find('.video-url-store') && $(this).find('.video-url-store')[0]
          videoUrl = videoHolder && $(videoHolder).val()
        }
      }

      var date = dateItem.textContent
      var title = $(titleItem).find('h6') && $(titleItem).find('h6')[0] && $(titleItem).find('h6')[0].textContent
      var description = $(ingressItem).find('p') && $(ingressItem).find('p')[0] && $(ingressItem).find('p')[0].textContent

      var shareHolder = $(this).find('.share-url-store') && $(this).find('.share-url-store')[0]
      var sharingUrl = shareHolder && $(shareHolder).val()

      var externalHolder = $(this).find('.external-video-store') && $(this).find('.external-video-store')[0]
      var externalVideo = externalHolder && $(externalHolder).val()

      // If any of the links in a video is clicked then the modal is opened
      $(this).find('a').each(function () {
        $(this).click(function () {
          // Parsing all the info about the clicked video to the modal
          for (const iframe of iframes) {
            iframe.classList.add('iframe-no-fullscreen')
          }

          if (externalVideo) {
            modalExternalVideo.src = externalVideo
            $(modalVideo).parent()[0].style.display = 'none'

            modalExternalVideoMobile.src = externalVideo
            $(modalVideoContent).parent()[0].style.display = 'none'
          } else {
            $(modalVideo).parent()[0].poster = imgUrl
            modalVideo.src = videoUrl
            $(modalExternalVideo).parent()[0].style.display = 'none'

            $(modalVideoContent).parent()[0].poster = imgUrl
            modalVideoContent.src = videoUrl
            $(modalExternalVideoMobile).parent()[0].style.display = 'none'
          }

          modalH2.textContent = title
          modalDescription.textContent = description
          modalDate.textContent = date

          // Activating social media sharers for the video
          $(modalFacebook).each(function () {
            $(this).click(function () {
              window.open('https://www.facebook.com/sharer/sharer.php?u=' + sharingUrl)
            })
          })

          $(modalTwitter).each(function () {
            $(this).click(function () {
              window.open('https://twitter.com/intent/tweet?text=' + title + '&url=' + sharingUrl)
            })
          })

          $(modalLinkedin).each(function () {
            $(this).click(function () {
              window.open('https://www.linkedin.com/shareArticle?url=' + sharingUrl)
            })
          })

          // Display the modal
          $(myModal).css({ display: 'block' })

          // Reload the video in the modal
          $(modalVideo).parent()[0].load()
          $(modalVideoContent).parent()[0].load()
        })
      })
    }
  })

  // Deal with close button of the modal
  $(myModal).find('button.close').click(function () {
    $(myModal).css({ display: 'none' })

    try { // Try/catch to avoid front-page video modals that don't use external parent to video
      // Giving back the styles the modal had before opening
      $(modalExternalVideo).parent()[0].style = externalStyles
      $(modalExternalVideoMobile).parent()[0].style = externalMobileStyles
      $(modalVideo).parent()[0].style = internalStyles
      $(modalVideoContent).parent()[0].style = internalMobileStyles
    } catch (e) {}

    if (siteBaseUrl) {
      const baseState = {}
      window.history.pushState(baseState, 'GK', siteBaseUrl)
    }
  })

  // Deal with fullscreen iframe to fix iPad Safari
  function changeHandler (e) {
    for (const iframe of iframes) {
      iframe.classList.toggle('iframe-no-fullscreen')
    }
  }

  document.addEventListener('fullscreenchange', changeHandler)
  document.addEventListener('webkitfullscreenchange', changeHandler)
  document.addEventListener('mozfullscreenchange', changeHandler)
  /* VIDEO MODAL END */
})
